// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/CollectionLabel/Content/History/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Payors_Content_Payors_Payor_Content_Content_CollectionLabel_Content_History($patient_id: numeric!, $payment_account_id: numeric!) {
  vaxiom_collection_label_history(
    where: {
      patient_id: { _eq: $patient_id }
      payment_account_id: { _eq: $payment_account_id }
    }
  ) {
    id
    patient_id
    payment_account_id
    created
    previous_collection_label_template {
      id
      name
      agency {
        id
        name
        phone_numer
      }
    }
    created_by_person {
      id
      first_name
      last_name
    }
  }
}

`